import * as React from "react";
const SvgCheckmark24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 15,
        fill: "black",
        viewBox: "0 0 20 15"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M19.207 2.207 7 14.414.793 8.207l1.414-1.414L7 11.586 17.793.793l1.414 1.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgCheckmark24Px;
